module.exports = __webpack_public_path__ + "media/images/riders/small/ANTON_SINTSOV-2e232427eb37dd69b4996ee8f666d63a.png";